<template>
  <AnalysisPage pageName="cancel" title="キャンセル" :disabled="busy || !qtyChart(keepUnit) || !rateChart(keepUnit)">
    <AnalysisContent>
      <template #unit>
        <Unit :refetch="fetch" :disabled="busy" />
      </template>
      <template #graph>
        <div class="chart-area">
          <AnalysisAggregate :busy="busy" :refetch="fetch" />
          <LoadingIndicator v-if="busy" />
          <div v-else-if="!qtyChart(keepUnit) || !rateChart(keepUnit)" class="no-data">
            <p>表示する内容がありません</p>
          </div>
          <template v-else>
            <FrameTemplate class="qty">
              <template #top>
                <div class="title">キャンセル</div>
              </template>
              <Chart
                type="ColumnChart"
                :data="qtyChart(keepUnit)"
                :options="options"
                :unit="keepUnit"
                :yearMonths="isMonthly(keepUnit) ? hAxis : []"
              />
              <template #v-axis-unit>組</template>
            </FrameTemplate>
            <FrameTemplate class="rate">
              <template #top>
                <div class="title">キャンセル率</div>
              </template>
              <Chart
                type="LineChart"
                :data="rateChart(keepUnit)"
                :options="rateOptions"
                :unit="keepUnit"
                :yearMonths="isMonthly(keepUnit) ? hAxis : []"
              />
              <template #v-axis-unit>%</template>
              <template #year-labels v-if="isMonthly(keepUnit)"><YearLabels :yearMonths="hAxis"/></template>
              <template #h-axis-unit>{{ unitById[keepUnit] }}</template>
            </FrameTemplate>
          </template>
        </div>
      </template>
      <template #table>
        <CancelTable :busy="busy" />
      </template>
    </AnalysisContent>
  </AnalysisPage>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AnalysisPage from '@/components/templates/AnalysisPage'
import AnalysisContent from '@/components/molecules/AnalysisContent'
import AnalysisAggregate, { Unit } from '@/components/organisms/AnalysisAggregate'
import Chart, { FrameTemplate, YearLabels } from '@/components/molecules/Chart'
import LoadingIndicator from '@/components/molecules/LoadingIndicator'
import CancelTable from './Components/CancelTable'

export default {
  name: 'AnalysisCancel',
  components: {
    AnalysisAggregate,
    AnalysisPage,
    AnalysisContent,
    Unit,
    Chart,
    FrameTemplate,
    YearLabels,
    LoadingIndicator,
    CancelTable,
  },
  data() {
    return {
      keepUnit: 0,
    }
  },
  computed: {
    ...mapState({
      busy: state => state.analysis.cancel.busy,
      conditions: state => state.analysis.aggregate.conditions,
      unitById: state => state.analysis.unit.shortById,
    }),
    ...mapGetters({
      query: 'analysis/aggregate/query',
      qtyChart: 'analysis/cancel/qtyChart',
      rateChart: 'analysis/cancel/rateChart',
      hAxis: 'analysis/cancel/hAxis',
      colors: 'analysis/cancel/colors',
      rateColors: 'analysis/cancel/rateColors',
      isMonthly: 'analysis/unit/isMonthly',
    }),
    options() {
      return {
        height: 172,
        isStacked: true,
        chartArea: {
          top: 6,
          bottom: 6,
        },
        hAxis: {
          textPosition: 'none',
        },
        colors: this.colors,
      }
    },
    rateOptions() {
      return {
        height: 116,
        chartArea: {
          top: 6,
          bottom: 20,
        },
        xAxis: {
          format: 'decimal',
        },
        colors: this.rateColors,
      }
    },
  },
  watch: {
    $route() {
      this.fetch()
    },
    busy(newValue) {
      if (!newValue) {
        this.keepUnit = this.conditions.unit
      }
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    async fetch() {
      const { dispatch } = this.$store
      const { unit, startTerm, endTerm } = this.query
      await dispatch('analysis/cancel/get', {
        unit,
        startTerm,
        endTerm,
      })
    },
  },
}
</script>

<style scoped lang="postcss">
>>> .graph {
  box-sizing: border-box;
}

.no-data {
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  height: 372px;
  justify-content: center;
}

.chart-area {
  height: 100%;
  width: 100%;

  .title {
    font-size: 11px;
    font-weight: 600;
    text-align: center;
  }

  .qty {
    height: 212px;
  }

  .rate {
    height: 136px;
  }
}
</style>
